import { Injectable, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { lastValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ApiUser } from '../../api-interfaces/api-user.interface';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { UserInterface } from '../../interfaces/user.interface';

export interface RegisterNewCompanyUserParams {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  role: string;
  can_grant_trial_access?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class UserService {

  http = inject(HttpClient);
  firestore = inject(AngularFirestore);

  constructor() { }

  getUserByFirebaseId(firebaseId: string): Promise<ApiUser> {
    return lastValueFrom(this.http.get<ApiUser>(`${environment.apiUrl}/users/firebase/${firebaseId}`));
  }

  editUserName(id: string, firstName: string, lastName: string): Promise<any> {
    const body = {
      first_name: firstName,
      last_name: lastName,
    };

    return lastValueFrom(this.http.put(`${environment.apiUrl}/users/${id}`, body));
  }

  // O backend cria o usuário JÁ vinculado à empresa (company_id) e aplica as
  // regras de perfil (anti-escalada) no servidor.
  async registerNewCompanyUser(data: RegisterNewCompanyUserParams, companyId: string) {
    await lastValueFrom(
      this.http.post<UserInterface>(`${environment.apiUrl}/users`, {
        ...data,
        company_id: companyId,
      }),
    );
    return;
  }

  // Edição por um gestor: nome, tipo de usuário e (opcionalmente) nova
  // senha — a senha é trocada no Firebase pelo backend.
  updateCompanyUser(
    userId: string,
    data: { first_name: string; last_name: string; role: string; password?: string; can_grant_trial_access?: boolean },
  ) {
    return lastValueFrom(this.http.put(`${environment.apiUrl}/users/${userId}`, data));
  }

  // Exclusão de usuário: o backend desativa o login, desfaz o vínculo com a
  // empresa e faz o soft-delete.
  deleteCompanyUser(userId: string, companyId: string) {
    return lastValueFrom(this.http.delete(`${environment.apiUrl}/users/${userId}`));
  }

  requestAccountDeletion(data: any) {
    this.firestore.collection('accountDeletionRequests').add(data);
  }
}
